<template>
    <b-container fluid class="mt--7">
        <b-card title="CRM Settings">
            <b-card-body>
                <b-form>
                    <b-form-group
                        id="fieldset-type_id"
                        label="Asset Type"
                        label-for="select-type_id"
                    >
                        <b-form-select
                            id="select-type_id"
                            v-model="formData.type_id"
                            :options="types"
                            text-field="name"
                            value-field="id"
                        >
                        </b-form-select>
                    </b-form-group>

                    <b-form-group
                        id="fieldset-vendor_id"
                        label="Asset Vendor"
                        label-for="select-vendor_id"
                    >
                        <b-form-select
                            id="select-vendor_id"
                            v-model="formData.vendor_id"
                            :options="vendors"
                            text-field="name"
                            value-field="id"
                        >
                        </b-form-select>
                    </b-form-group>

                    <b-button variant="link" @click="updateTypes"
                        >Update</b-button
                    >
                </b-form>
            </b-card-body>
        </b-card>
    </b-container>
</template>

<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'crmSetting',
    mixins: [popupMixins, permissionsMixins],
    data: () => ({
        formData: {
            type_id: null,
            vendor_id: null,
        },
        updating: false,
    }),

    computed: {
        crmSettingValue() {
            const  crmSettingValue = this.$store.getters['company/crmSettingValue']
            console.log('computed  crmSettingValue', crmSettingValue)
            return  crmSettingValue
        },

        types() {
            return this.$store.state.assets.types
        },

        vendors() {
            return this.$store.state.assets.vendors
        },

        crmsettingsKey() {
            return this.$store.state.company.settingKeys.crmsettingsKey
        },
    },

    watch: {
        crmSettingValue: {
            handler: function (val) {
                console.log('watch crmSettingValue', val)
                this.updateModel(val)
            },
            deep: true,
        },
        vendors: {
            handler: function (val) {
                console.log('watch vendors', val)
            },
            deep: true,
        },
    },

    created() {
        this.$store.dispatch('assets/listTypes')
        this.$store.dispatch('assets/listVendors')
    },

    async mounted() {
        await this.$store.dispatch(
            'company/fetchConfiguration',
            this.crmsettingsKey
        )
        this.$nextTick(() => {
            this.updateModel(this.crmSettingValue)
        })
    },

    methods: {
        updateModel(crmSettingValue) {
            this.formData = crmSettingValue
        },
        async updateTypes() {
            try {
                this.updating = true
                const text_value = JSON.stringify(this.formData)
                const bool_value = false

                this.$store.dispatch('company/updateConfiguration', {
                    key: this.crmsettingsKey,
                    text_value,
                    bool_value,
                })
                this.doToast('Success!', 'Settings Updated', 'success')
            } catch (error) {
                this.doToast('Error!', error.message, 'danger')
            } finally {
                this.updating = false
            }
        },
    },
}
</script>
